module.exports = __webpack_public_path__ + "static/media/UserPath1.711c63dc.png";